import { Route, Routes } from "react-router-dom"
import "./App.css"
import Header from "./components/header"
import { Toaster } from "./components/ui/sonner"
import Home from "./pages/Home/Home"
import Vacature from "./pages/Vacture/Vacature"
import Kandidaat from "./pages/Kandidaat/Kandidaat"
import AuthGate from "./auth/AuthGate"

function App() {
  return (
    <>
      <Header />
      <AuthGate>
        <Routes>
          <Route path="/vacature/:slug" element={<Vacature />} />
          <Route path="/vacature/:vacancyId/kandidaat/:candidateId" element={<Kandidaat />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </AuthGate>
      <Toaster position="bottom-center"/>
    </>
  )
}

export default App
